/** @file docHash cadence (spec §9): after every 50th commit and after each hello, outside the sync loop. */
import { contentHash } from '@pose2d/api/render/contentHash';
import { docStore } from '../../stores/docStore';
import type { SyncSession } from './liveSession';

const EVERY = 50;

/** When to send `{ t: 'hash' }` and how (E8-R2). */
export const hashCheck = {
  /** Commits between two checks. */
  EVERY,
  /** True when going from rev `from` to rev `to` passes a multiple of EVERY. */
  crosses: (from: number, to: number): boolean => Math.floor(from / EVERY) < Math.floor(to / EVERY),
  /** Sends the confirmed document's hash when one is due and no sync runs; stays due while the socket is down. */
  flush(session: SyncSession): void {
    const { slice } = docStore.getState();
    if (!session.hashDue || session.busy !== null || slice === null) return;
    if (session.send({ t: 'hash', rev: slice.rev, docHash: contentHash(slice.confirmed) })) session.hashDue = false;
  },
};
